import {combineReducers, applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import ReduxThunk from 'redux-thunk';
import ForYouReducer from "../modules/ForYou";
import MixerReducer from "../modules/Mixer";
import AllBrandsReducer from "../modules/CatalogBrands";
import TastesBrandReducer from '../modules/TastesBrand';
import SystemReducer from "../modules/System";
import MainReducer from "../modules/Main";
import FavoriteReducer from "../modules/Favorite";
import PreferencesReducer from "../modules/Preferences";
import ChangePreferencesReducer from "../modules/ChangePreferences";
import SelectionPreferencesReducer from "../modules/SelectionPreferences";
import shareReducer from "../modules/Share";

const rootReducer = combineReducers({
  preferences: PreferencesReducer,
  main: MainReducer,
  forYou: ForYouReducer,
  mixer: MixerReducer,
  catalogBrands: AllBrandsReducer,
  tastesBrand: TastesBrandReducer,
  system: SystemReducer,
  favorite: FavoriteReducer,
  changePreferences: ChangePreferencesReducer,
  selectionPreferences: SelectionPreferencesReducer,
  share: shareReducer
});

type CombineReducersType = typeof rootReducer;
export type AppStateType = ReturnType<CombineReducersType>

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(ReduxThunk, logger)));

export default store;
